import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'av-footer',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './av-footer.component.html',
  styleUrl: './av-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class AvFooterComponent {
  readonly version = environment.version;
}
